module.exports = __webpack_public_path__ + "static/media/video.9bcf1652.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/video.mp4
// module id = 194
// module chunks = 0